import { render, staticRenderFns } from "./BtnAtualizarUnidadeRegional.vue?vue&type=template&id=c8e7f2bc"
import script from "./BtnAtualizarUnidadeRegional.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarUnidadeRegional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports